export default __webpack_public_path__ + "static/media/gitaar-3.ba192dbd.png";